import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=1159990a&"
import script from "./pageLayout.vue?vue&type=script&lang=ts&"
export * from "./pageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ESection: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/section.vue').default,MypageSubMenu: require('/var/lib/jenkins/workspace/e-world-nuxt/components/mypage/subMenu.vue').default})
